import PropTypes from "prop-types";

export const eventCardShape = PropTypes.shape({
  _id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  eventName: PropTypes.string,
  eventType: PropTypes.string,
  status: PropTypes.string,
  isPublic: PropTypes.bool,
  isFeeBased: PropTypes.bool,
  feeAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  registrationType: PropTypes.string,
  registrationConfig: PropTypes.shape({
    isPublicRegistrationEnabled: PropTypes.bool,
  }),
  bookingRegistrationCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bookingParticipantCount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasAttendees: PropTypes.arrayOf(PropTypes.shape({})),
  participants: PropTypes.arrayOf(PropTypes.shape({})),
  rsvpDeclined: PropTypes.arrayOf(PropTypes.shape({})),
  maxParticipants: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  eventDateBegin: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  eventDateEnd: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  locationName: PropTypes.string,
  city: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
});
